import React, { Component } from 'react'
import { StaticBox, LinkedInput, LinkedToggle } from 'components/basic'
import { notify } from 'helpers'
import http from 'API/http'
import { connect } from 'react-redux'

class UserCreator extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: {}
    }
  }

  async createUser () {
    var err, res
    [err, res] = await http.post('2.4/users/', this.state.user)
    if (err) return notify.alert('', res.cause ? res.cause : 'Creating  user failed', 'error')
    notify.success('User created')
    window.location = '/#/users/' + res.data.userId
    this.setState({editable: false})
  }

  render () {
    return (
      <StaticBox cols={12} icon='user' title='Create' buttons={[ { icon: 'fa-save', event: () => this.createUser(), datatip: 'Save' } ]}>
        <div className='row'>
          <div className='col-md-3'>
            <label>Name</label>
            <LinkedInput context={this} path='user.name' />
          </div>
          {this.props.access !== 'FLOW' && <div className='col-md-3'>
            <label>Username</label>
            <LinkedInput context={this} path='user.username' />
          </div>}
          <div className='col-md-3'>
            <label>Email</label>
            <LinkedInput context={this} path='user.email' />
          </div>
          <div className='col-md-3'>
            <label>Password</label>
            <LinkedInput type='password' context={this} editable={this.state.editable} path='user.password' name='password' />
          </div>
          <div className='col-md-3'>
            <label>Administrator</label>
            <LinkedToggle context={this} path='user.isAdmin' name='Administrator' />
          </div>
        </div>
      </StaticBox>
    )
  }
}

//eslint-disable-next-line
UserCreator = connect(state => state.siteReducer)(UserCreator)
export default UserCreator



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/users/UserCreator.js